import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import React, {
    CSSProperties,
    useEffect,
    useMemo,
    // useEffect,
    useRef,
    useState
} from "react";
import ReactSelect, { OptionProps } from "react-select";
import uuid from "react-uuid";
import styles from "./Select.module.scss";
import { customStyles } from "./types";

// const BORDER_COLOR = scss["purple"];
const BORDER_COLOR = "#1B91BC";
//const NOT_FOCUS_BORDER_COLOR = scss["lightGrey6"];
const NOT_FOCUS_BORDER_COLOR = "#1B91BC";

const PLACEHOLDER_COLOR = "#ACACAE";

export interface SelectOption {
    topic: string;
    value: string;
    label: string;
}

export const SelectOption: React.FC<OptionProps> = props => {
    const { innerProps, getStyles, data } = props;
    const _data = data as SelectOption;
    const ref = useRef();

    // useEffect(() => {
    //     const id = uniqueId();
    //     let element = window.document.getElementById(id);
    //     if (!element) {
    //         element = window.document.createElement("div");
    //         element.id = id;
    //         window.document.body.append(element);
    //     }
    //     element.innerHTML = (ref.current as HTMLElement).parentElement.parentElement.outerHTML;
    // }, []);

    let _styles = getStyles("option", props);
    const __styles = _.omit(_styles, ["label", ":active"]) as CSSProperties;

    return (
        <div
            ref={ref}
            style={{
                ...__styles,
                cursor: "pointer"
            }}
            className={styles.option}
            {...innerProps}
        >
            {_data.label}
        </div>
    );
};

interface SelectProps {
    options: SelectOption[];
    value: SelectOption;
    onChange?: (item: SelectOption) => void;
    placeholder: string;
    className?: string;
    selectClassName?: string;
    containerClassName?: string;
    themeColor?: string;
    focusBorderWidth?: number;
    notFocusBorderWidth?: number;
}
export const Select: React.FC<SelectProps> = ({
    className,
    containerClassName,
    selectClassName,
    options,
    value,
    placeholder,
    themeColor = BORDER_COLOR,
    focusBorderWidth = 2.4,
    notFocusBorderWidth = 2,
    onChange
}) => {
    const [_value, _setValue] = useState<SelectOption>(value);

    useEffect(() => {
        _setValue(value);
    }, [value]);

    const _onChange = useMemo(() => {
        return (item: SelectOption) => {
            _setValue(item);
        };
    }, []);

    return (
        <div className={`${className ?? ""} ${containerClassName ?? ""} react-select ${styles.reactSelect}`}>
            <ReactSelect
                className={`${selectClassName ?? ""} react-select-element`}
                menuPortalTarget={document.body}
                components={{ Option: SelectOption }}
                styles={
                    //     {
                    //     menuPortal: provided => ({
                    //         ...provided,
                    //         zIndex: 9999
                    //     }),
                    //     menu: provided => {
                    //         return {
                    //             ...provided,
                    //             zIndex: 6,
                    //             border: `1px solid ${NOT_FOCUS_BORDER_COLOR}`
                    //         };
                    //     },
                    //     placeholder: provided => {
                    //         console.log(provided);
                    //         return {
                    //             ...provided,
                    //             color: PLACEHOLDER_COLOR
                    //         };
                    //     },

                    //     control: (provided, { isFocused }: { isFocused: boolean }) => {
                    //         return {
                    //             ...provided,
                    //             borderColor: !isFocused ? `${NOT_FOCUS_BORDER_COLOR}!important` : `${themeColor}!important`,
                    //             borderWidth: !isFocused ? `${notFocusBorderWidth}px` : `${focusBorderWidth}px`,
                    //             ...(!isFocused
                    //                 ? {
                    //                       boxShadow: "none"
                    //                   }
                    //                 : {
                    //                       boxShadow: `0 0 0 .5px ${themeColor}`
                    //                   })
                    //         };
                    //     }
                    // }
                    {
                        ...customStyles,
                        menuPortal: provided => ({
                            ...provided,
                            zIndex: 9999
                        }),
                        menu: provided => {
                            return {
                                ...provided,
                                zIndex: 6,
                                border: `1px solid ${NOT_FOCUS_BORDER_COLOR}`
                            };
                        },
                        placeholder: provided => {
                            return {
                                ...provided,
                                color: PLACEHOLDER_COLOR
                            };
                        },
                        control: (provided, { isFocused }: { isFocused: boolean }) => {
                            return {
                                ...provided,
                                borderColor: !isFocused
                                    ? `${NOT_FOCUS_BORDER_COLOR}!important`
                                    : `${themeColor}!important`,
                                borderWidth: !isFocused ? `${notFocusBorderWidth}px` : `${focusBorderWidth}px`,
                                ...(!isFocused
                                    ? {
                                          boxShadow: "none"
                                      }
                                    : {
                                          boxShadow: `0 0 0 .5px ${themeColor}`
                                      })
                            };
                        }
                    }
                }
                inputId={uuid()}
                value={_value}
                onChange={onChange ?? _onChange}
                options={options}
                placeholder={placeholder}
                theme={theme => {
                    return {
                        ...theme,
                        colors: {
                            ...theme.colors,
                            primary: BORDER_COLOR,
                            primary25: BORDER_COLOR,
                            primary50: BORDER_COLOR,
                            primary75: BORDER_COLOR
                            //themeColor as string
                        }
                    };
                }}
            />
            <div className={styles.selectArrowIndicator}>
                <FontAwesomeIcon icon={faChevronDown} />
            </div>
        </div>
    );
};

export const SelectDemo = () => {
    return (
        <Select
            options={[
                {
                    label: "www",
                    topic: "www",
                    value: "wwqwww"
                },
                {
                    label: "www11",
                    topic: "www11",
                    value: "wwqwww223"
                }
            ]}
            value={null}
            placeholder={"qqqqqqqqq"}
        />
    );
};
